import { render, staticRenderFns } from "./application-form.vue?vue&type=template&id=519f0a0e&scoped=true&"
import script from "./application-form.vue?vue&type=script&lang=js&"
export * from "./application-form.vue?vue&type=script&lang=js&"
import style0 from "./application-form.vue?vue&type=style&index=0&id=519f0a0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f0a0e",
  null
  
)

export default component.exports